import TextField from '../text-field';
import NumberTextField from '../number-text-field';
import MoneyTextField from '../money-text-field';
import FundsRegisterNumberTextField from '../funds-register-number-text-field';
import CardNumberTextField from '../card-number-text-field';
import CardExpirationTextField from '../card-expiration-text-field';
import CopyToClipboardTextField from '../copy-to-clipboard-text-field';
import PasswordTextField from '../password-text-field';
import Autocomplete from '../autocomplete';
import SelectField from '../select-field';
import DatePicker from '../date-picker';
import Button from '../button';
import Checkbox from '../checkbox';
import ImageUploader from '../image-uploader';
import {
	withFormTextField,
	withFormAutocomplete,
	withFormSelectField,
	withFormDatePicker,
	withSubmitForm,
	withFormCheckbox,
	withFormImageUploader,
} from './hocs';


const FormTextField = withFormTextField<Omit<React.ComponentProps<typeof TextField>, 'name'>, any>(TextField);
const FormNumberTextField = withFormTextField<Omit<React.ComponentProps<typeof NumberTextField>, 'name'>, any>(NumberTextField);
const FormMoneyTextField = withFormTextField<Omit<React.ComponentProps<typeof MoneyTextField>, 'name'>, any>(MoneyTextField);
const FormFundsRegisterNumberTextField = withFormTextField<Omit<React.ComponentProps<typeof FundsRegisterNumberTextField>, 'name'>, any>(FundsRegisterNumberTextField);
const FormCardNumberTextField = withFormTextField<Omit<React.ComponentProps<typeof CardNumberTextField>, 'name'>, any>(CardNumberTextField);
const FormCardExpirationTextField = withFormTextField<Omit<React.ComponentProps<typeof CardExpirationTextField>, 'name'>, any>(CardExpirationTextField);
const FormCopyToClipboardTextField = withFormTextField<Omit<React.ComponentProps<typeof CopyToClipboardTextField>, 'name'>, any>(CopyToClipboardTextField);
const FormPasswordTextField = withFormTextField<Omit<React.ComponentProps<typeof PasswordTextField>, 'name'>, any>(PasswordTextField);
const FormAutocomplete = withFormAutocomplete<Omit<React.ComponentProps<typeof Autocomplete>, 'name'>, any>(Autocomplete);
const FormSelectField = withFormSelectField<Omit<React.ComponentProps<typeof SelectField>, 'name'>, any>(SelectField);
const FormDatePicker = withFormDatePicker<Omit<React.ComponentProps<typeof DatePicker>, 'name'>, any>(DatePicker);
const FormSubmitButton = withSubmitForm<React.ComponentProps<typeof Button>>('onClick')(Button);
const FormCheckbox = withFormCheckbox<Omit<React.ComponentProps<typeof Checkbox>, 'name'>, any>(Checkbox);
const FormImageUploader = withFormImageUploader<Omit<React.ComponentProps<typeof ImageUploader>, 'name'>, any>(ImageUploader);

export {
	FormTextField,
	FormNumberTextField,
	FormMoneyTextField,
	FormFundsRegisterNumberTextField,
	FormCardNumberTextField,
	FormCardExpirationTextField,
	FormCopyToClipboardTextField,
	FormPasswordTextField,
	FormAutocomplete,
	FormSelectField,
	FormDatePicker,
	FormSubmitButton,
	FormCheckbox,
	FormImageUploader,
};
